import assetPath from '/app/packages/lebenslauf/components/src/assets/open-sans-condensed-light.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')